<app-status-tag [status]="post.status"></app-status-tag>
<div class="actions">
    <button class="update" mat-icon-button (click)="updatePost.emit(post)"
        matTooltip="{{ 'crud.actions.update' | translate }}">
        <mat-icon aria-hidden="false" aria-label="pencil" svgIcon="pencil"></mat-icon>
    </button>
    <button class="unvalidate" mat-icon-button (click)="invalidatePost.emit(post)" [disabled]="!post.validatedAt"
        matTooltip="{{ 'crud.actions.unvalidate' | translate }}">
        <mat-icon aria-hidden="false" aria-label="file-alert" svgIcon="file-alert"></mat-icon>
    </button>
    <button class="delete" mat-icon-button (click)="deletePost.emit(post)"
        matTooltip="{{ 'crud.actions.delete' | translate }}">
        <mat-icon aria-hidden="false" aria-label="trash" svgIcon="trash"></mat-icon>
    </button>
</div>
<div class="actions">
<!--    <button class="validate" mat-icon-button (click)="validate()" [disabled]="post.validatedAt"-->
<!--        matTooltip="{{ 'crud.actions.validate' | translate }}">-->
<!--        <mat-icon aria-hidden="false" aria-label="check" svgIcon="check"></mat-icon>-->
<!--        <mat-icon aria-hidden="false" aria-label="currency-euro" svgIcon="currency-euro"></mat-icon>-->
<!--    </button>-->
    <button class="validate-free" mat-icon-button (click)="validateFree()" [disabled]="post.validatedAt"
        matTooltip="{{ 'crud.actions.validate' | translate }}">
        <mat-icon aria-hidden="false" aria-label="check" svgIcon="check"></mat-icon>
        <mat-icon aria-hidden="false" aria-label="currency-euro-free" svgIcon="currency-euro-free"></mat-icon>
    </button>
</div>
<span class="moderator_text">Administration</span>
